/**
 * アプリケーション設定ユーティリティ
 *
 * 環境変数から設定を読み込み、アプリケーション全体で使用します。
 */

/**
 * 料金徴収機能が有効かどうか
 *
 * 環境変数 `VITE_BILLING_ENABLED` が "true" の場合のみ有効
 * デフォルト: false（無料開放中）
 */
export const isBillingEnabled = (): boolean => {
  return import.meta.env.VITE_BILLING_ENABLED === 'true';
};

/**
 * 料金徴収機能が無効（無料開放中）かどうか
 */
export const isBillingFree = (): boolean => {
  return !isBillingEnabled();
};

/**
 * 遺伝子解析を一般認証ユーザーに公開するか。
 * デフォルト false = 開発中（システム管理者のみ）。
 */
export const isGeneAnalysisPublicEnabled = (): boolean => {
  return import.meta.env.VITE_GENE_ANALYSIS_PUBLIC_ENABLED === 'true';
};

/**
 * ラボ助をログイン不要で公開するか。
 * デフォルト true（未ログイン可）。`VITE_LABO_SUKE_PUBLIC_ENABLED=false` のときは研助ログイン＋管理者のみ。
 */
export const isLaboSukePublicEnabled = (): boolean => {
  return import.meta.env.VITE_LABO_SUKE_PUBLIC_ENABLED !== 'false';
};

/**
 * 交通IC・共用カードをログイン不要で公開するか。
 * デフォルト true（未ログイン可）。`VITE_TPP_PUBLIC_ENABLED=false` のときは研助ログイン必須。
 */
export const isTppPublicEnabled = (): boolean => {
  return import.meta.env.VITE_TPP_PUBLIC_ENABLED !== 'false';
};

/**
 * サンプル管理をログイン不要（Zip ローカル）でも公開するか。
 * デフォルト true。ログイン時は従来どおり DB 正本。
 * `VITE_SAMPLE_PUBLIC_ENABLED=false` のときはログイン必須（DB のみ）。
 */
export const isSamplePublicEnabled = (): boolean => {
  return import.meta.env.VITE_SAMPLE_PUBLIC_ENABLED !== 'false';
};

/**
 * 計助をログイン不要で公開するか。
 * デフォルト true（未ログイン可）。`VITE_KEISUKE_PUBLIC_ENABLED=false` のときは研助ログイン必須。
 */
export const isKeisukePublicEnabled = (): boolean => {
  return import.meta.env.VITE_KEISUKE_PUBLIC_ENABLED !== 'false';
};
/** システム管理者メール（お問い合わせ・不具合報告・機能要望の窓口） */
export const SYSTEM_ADMIN_EMAIL = 'admin@kensuke-system.com';

/**
 * お問い合わせ掲示板UI（/contact への導線）を表示するか。
 * false のときはトップ・ダッシュボードから管理者メールへ誘導する。
 * 問い合わせ増加時は true に戻して掲示板機能を復活させる。
 */
export const COMMUNICATION_BOARD_UI_ENABLED = false;

/** 管理者宛 mailto リンク */
export const buildAdminMailtoHref = (subject?: string): string => {
  const base = `mailto:${SYSTEM_ADMIN_EMAIL}`;
  if (!subject) return base;
  return `${base}?subject=${encodeURIComponent(subject)}`;
};
